import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";

export type CustomerInfo = {
  shouldDisplaySupportNotification: boolean;
  activeSubscription: boolean;
};

export type PortalStateModel = {
  modal: { opened: boolean; success: boolean; closable: boolean };
  customerInfo: CustomerInfo;
};

const initialState: PortalStateModel = {
  modal: {
    opened: false,
    success: false,
    closable: false,
  },
  customerInfo: {
    shouldDisplaySupportNotification: false,
    activeSubscription: false,
  },
};

export const PortalStore = signalStore(
  { providedIn: "root" },
  withState<PortalStateModel>(initialState),
  withMethods((store) => ({
    set(customerInfo: CustomerInfo) {
      patchState(store, { customerInfo });
    },
    reset() {
      patchState(store, initialState);
    },
    setSuccess() {
      patchState(store, { modal: { ...store.modal(), success: true } });
    },
    openModal(closable?: boolean) {
      patchState(store, { modal: { ...store.modal(), opened: true, closable: closable ? closable : false } });
    },
    closeModal() {
      patchState(store, { modal: { ...store.modal(), opened: false, success: false } });
    },
  })),
);
